import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MarketingAPI } from 'src/app/services/marketing/marketing.api';
import {
  MarketingPageGetResponse,
  MarketingPageGetResponseItem,
} from 'src/app/services/marketing/marketing_page_get';
import * as uuid from 'uuid';
import { MarketingMaterialViewComponent } from './marketing-material-view/marketing-material-view.component';

@Component({
  selector: 'app-marketing-material',
  templateUrl: './marketing-material.component.html',
  styleUrls: ['./marketing-material.component.scss'],
})
export class MarketingMaterialComponent implements OnInit {
  constructor(private api: MarketingAPI, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.api.marketingPageGet('zeropay').then((r) => {
      this.response = r;

      const data: any[] = [];

      if (r.data?.items) {
        const grouped: any = this.groupBy(
          r.data?.items,
          'marketingItemCategoryId'
        );

        const keys = Object.keys(grouped);

        for (let i = 0; i < keys.length; i++) {
          const cat = r.data!.items!.find(
            (x: any) => x.marketingItemCategoryId == +keys[i]
          );

          const id = uuid
            .v4()
            .replace('-', '')
            .replace('-', '')
            .replace('-', '')
            .replace('-', '')
            .replace('-', '');

          data.push({
            category: {
              categoryId: cat?.marketingItemCategoryId,
              id: `item_${id}`,
              descriptor: cat?.marketingItemCategoryDescriptor,
            },

            items: grouped[keys[i]],
          });
        }
      }

      this.groupedData = data;
    });
  }

  public scrollTo(elementId: string): void {
    (document.querySelector(`#${elementId}`) as Element).scrollIntoView({
      behavior: 'smooth',
    });
  }

  public response: MarketingPageGetResponse | undefined = undefined;
  public groupedData: any = undefined;

  groupBy(xs: any, key: any) {
    return xs.reduce(function (rv: any, x: any) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  view(item: MarketingPageGetResponseItem) {
    this.dialog.open(MarketingMaterialViewComponent, {
      data: item,
      panelClass: 'custom-dialog',
      width: '100%',
      height: '100%',
      maxHeight: '100vh',
    });
  }
}
